import styled, { css } from 'styled-components';
import { selectColor } from '@panel/commons/core/theme';
import { select } from '@panel/commons/core/themev2';
import ArrowUp from '../../assets/icons/arrowUp.svg';
import ArrowDown from '../../assets/icons/arrowDown.svg';
import Neutral from '../../assets/icons/neutralIcon.svg';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  ${({ isDesktop }) =>
    !isDesktop &&
    css`
      flex-direction: row;
      gap: 3px;
    `}
`;

const HeaderArea = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

const Icon = styled.img`
  width: ${({ isDesktop }) => (isDesktop ? 40 : 48)}px;
  height: ${({ isDesktop }) => (isDesktop ? 40 : 48)}px;
  margin-right: 16px;
`;

const TitleText = styled.h1`
  font-family: 'Hind';
  font-style: normal;
  font-weight: 600;
  font-size: ${({ device }) => (device === 'tablet' ? 18 : 16)}px;
  line-height: 130%;
  height: 21px;
  margin-right: 9px;
  ${({ device }) =>
    device !== 'desktop' &&
    css`
      margin-bottom: 4px;
    `}
`;

const TooltipComponent = styled.div`
  padding: 3px 8px;
  width: ${({ type }) => (type === 'header' ? 278 : 172)}px;
  height: 44px;
  white-space: pre-wrap;
  text-align: center;
`;

const IconTooltip = styled.img`
  margin-top: 6px;
`;

const InfoArea = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  height: 110px;
  ${({ device }) =>
    device !== 'mobile' &&
    css`
      min-width: 270px;
    `}
  p {
    font-family: 'Hind';
    font-style: normal;
    font-weight: ${({ device }) => (device === 'mobile' ? 500 : 400)};
    font-size: ${({ device }) => (device === 'tablet' ? 16 : 12)}px;
    line-height: ${({ device }) => (device === 'tablet' ? 26 : 19)}px;
    color: ${selectColor('grayDarkLight')};
    margin-bottom: 10px;
  }
  ${({ device }) =>
    device !== 'desktop' &&
    css`
      width: 100%;
      height: fit-content;
      margin-bottom: 0px;
      p {
        margin-bottom: 8px;
        width: ${device === 'mobile' ? '200px' : 'auto'};
        white-space: pre-line;
      }
    `}
`;

const DataWraper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${({ withSeparator }) =>
    withSeparator &&
    css`
      border-top: 1px solid ${selectColor('grayMedium')};
      margin-top: 5px;
      padding-top: 9px;
    `}
  ${({ device }) =>
    device === 'tablet' &&
    css`
      justify-content: flex-start;
      gap: 30px;
    `}
`;

const ContainerValue = styled.div`
  display: flex;
  align-items: center;
  font-family: 'Hind';
  font-style: normal;
  text-align: start;
  .aditional-text {
    align-self: flex-end;
    font-weight: 400;
    font-size: ${({ device }) => (device === 'mobile' ? 12 : 14)}px;
    line-height: ${({ device }) => (device === 'mobile' ? 19 : 22)}px;
    color: ${selectColor('grayDarkLight')};
    margin-left: 10px;
    margin-top: 1px;
    margin-right: 5px;
    ${({ withAnonymous }) =>
      withAnonymous &&
      css`
        font-size: ${({ device }) => (device === 'tablet' ? 16 : 12)}px;
        line-height: ${({ device }) => (device === 'tablet' ? 26 : 19)}px;
      `}
  }
`;

const AnonymousText = styled.div`
  font-weight: 600;
  font-size: ${({ device }) => (device === 'tablet' ? 15 : 12)}px;
  line-height: 19px;
  color: ${selectColor('black')};
  margin-left: ${({ withMarginLeft }) => (withMarginLeft ? '10' : '0')}px;
  margin-top: ${({ device }) => (device === 'desktop' ? 4 : -2)}px;
  margin-bottom: ${({ device }) => (device === 'desktop' ? 0 : 8)}px;
  margin-right: 5px;
`;

const StyleValue = styled.div`
  font-family: 'Hind';
  font-style: normal;
  font-weight: ${({ type }) => (type === 'secondary' ? 600 : 700)};
  font-size: ${({ type }) => (type === 'secondary' ? 16 : 24)}px;
  line-height: 130%;
  color: ${({ withAnonymous }) => selectColor(withAnonymous ? 'grayDarkLight' : 'black')};
`;

const pillsColors = {
  ALTO: {
    color: 'snackGreen',
    background: 'positiveBack',
    icon: ArrowUp
  },
  EQUAL: {
    color: 'darkGray',
    background: 'middleGray',
    icon: Neutral
  },
  BAJO: {
    color: 'negative',
    background: 'midNegative',
    icon: ArrowDown
  }
};

const PercentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ score }) => select(pillsColors[score].background)};
  border-radius: 12px;
  padding: 0 4px;
  height: 16px;
  .arrow {
    width: 7.5px;
    height: ${({ score }) => (pillsColors[score].icon === Neutral ? 2 : 9)}px;
    background-size: cover;
    background-image: url(${({ score }) => pillsColors[score].icon});
    margin-right: 3px;
  }
  .valuePercent {
    font-family: 'Hind';
    font-style: normal;
    font-weight: 500;
    font-size: 11px;
    line-height: 20px;
    color: ${({ score }) => select(pillsColors[score].color)};
    margin-top: 2px;
  }
  @media screen and (max-width: 329px) {
    margin-right: 11px;
  }
`;

const DataWraperWithAnonymous = styled.div``;

export {
  Container,
  HeaderArea,
  Icon,
  TitleText,
  TooltipComponent,
  IconTooltip,
  InfoArea,
  DataWraper,
  ContainerValue,
  AnonymousText,
  StyleValue,
  PercentContainer,
  DataWraperWithAnonymous
};
